import React from "react";
import ValidatedInput from "../../utils/components/ValidatedInput";
import ValidatedForm from "../../utils/components/ValidatedForm";
import SubmitButton from "../../utils/components/SubmitButton";
import assign from "object-assign";
import { mailingListUrl as FIREBASE_URL } from "../../config/config";
import Firebase from "firebase";

let MailingList = React.createClass({
    getInitialState() {
        return {
            data: {},
            submitted: false
        };
    },
    handleEmailSubmit(data, reset, invalidate) {
        let ref = new Firebase(FIREBASE_URL);

        ref.authAnonymously((error, authData) => {
            if (error) {
                invalidate({"": "Error: Could not connect to db"});
            } else {
                ref.child("emails").update({
                    [authData.uid]: assign(data, {
                        created: Firebase.ServerValue.TIMESTAMP
                    }, this.props.pro ? { pro: true }: {})
                }, (err) => {
                    if (err) {
                        invalidate({"": "Error: Could not save email address"});
                    } else {
                        reset(this.props.replace ? null : this.props.successMessage);
                        this.setState({submitted: true});
                        if (this.props.onSuccess) {
                            this.props.onSuccess();
                        }
                    }
                });
            }
        });
    },
    render() {
        return this.state.submitted && this.props.replace ? <div className={`eo-mailing-list submitted ${this.props.className || ""}`}><p className="success-message">{this.props.successMessage}</p></div> :
            (
                <ValidatedForm ref="form" className={`eo-mailing-list ${this.props.className || ""}`} data={this.state.data} handleSubmit={this.handleEmailSubmit}>
                    <ValidatedInput
                        placeholder={this.props.placeholder || "Enter your email to stay in the loop"}
                        name="email"
                        className="email-input"
                        validations="isEmail"
                        validationError="Invalid Email"
                        autoComplete={false}
                        required/>
                    <SubmitButton className="email-submit" text={this.props.buttonText || "$icon"} submittingText={this.props.submittingText || "$icon"} btnClassName="icon eo-icon-play"/>
                </ValidatedForm>
            );
    }
});

export default MailingList;



/** WEBPACK FOOTER **
 ** ./app/views/components/MailingList.js
 **/